import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { Card, CardContent, Typography, Grid } from "@mui/material";

/* Effort distribution (static for now) */
const effortData = [
  { name: "Development", value: 55 },
  { name: "Testing", value: 20 },
  { name: "Meetings", value: 15 },
  { name: "Research", value: 10 },
];

const COLORS = ["#6366F1", "#8B5CF6", "#A78BFA", "#C4B5FD"];

export default function Charts({ trendData }) {
  // ensure data is always an array
  const data = Array.isArray(trendData) ? trendData : [];

  return (
    <Grid container spacing={3} sx={{ mt: 1 }}>
      
      {/* Productivity Trend */}
      <Grid item xs={12} md={8}>
        <Card
          sx={{
            border: "1px solid #E2E8F0",
            boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
          }}
        >
          <CardContent>
            <Typography fontWeight="bold" mb={2}>
              Productivity Trend
            </Typography>

            {/* loading message */}
            {data.length === 0 && (
              <Typography color="text.secondary" sx={{ mb: 2 }}>
                Loading productivity trend...
              </Typography>
            )}

            <ResponsiveContainer width="100%" height={260}>
              {/* key forces redraw when data changes */}
              <LineChart key={data.length} data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip formatter={(value) => `${value} hrs`} />
                <Line
                  type="monotone"
                  dataKey="hours"
                  stroke="#6366F1"
                  strokeWidth={3}
                  dot={{ r: 4 }}
                  activeDot={{ r: 6 }}
                />
              </LineChart>
            </ResponsiveContainer>

          </CardContent>
        </Card>
      </Grid>

      {/* Effort Distribution */}
      <Grid item xs={12} md={4}>
        <Card
          sx={{
            border: "1px solid #E2E8F0",
            boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
          }}
        >
          <CardContent>
            <Typography fontWeight="bold" mb={2}>
              Effort Distribution
            </Typography>

            <ResponsiveContainer width="100%" height={260}>
              <PieChart>
                <Pie
                  data={effortData}
                  cx="50%"
                  cy="50%"
                  outerRadius={90}
                  dataKey="value"
                  label
                >
                  {effortData.map((entry, index) => (
                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid>

    </Grid>
  );
}